import { render, staticRenderFns } from "./FacilityEditTabRelease.vue?vue&type=template&id=2c2b3c89&"
import script from "./FacilityEditTabRelease.vue?vue&type=script&lang=js&"
export * from "./FacilityEditTabRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports